export default __webpack_public_path__ + "static/media/no-image.2f872eb9.svg";